"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importStar(require("react"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const FormalReviewClient_1 = require("client/FormalReviewClient");
const useIntersectionObserver_1 = __importDefault(require("hooks/useIntersectionObserver"));
const HelperUtils_1 = require("utils/HelperUtils");
const Button_1 = __importDefault(require("components/design-system/Button"));
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const InlineDialog_1 = __importDefault(require("components/design-system/inline-dialog/InlineDialog"));
const ModalRemoveReviewer_1 = __importDefault(require("components/formal-review/sidebar-phase/ModalRemoveReviewer"));
const MenuOutsideClickWrapper_1 = __importDefault(require("components/objectives/compact-objective/fragments/MenuOutsideClickWrapper"));
const BannerBox_1 = __importDefault(require("components/shared/BannerBox"));
const ListEmptyState_1 = __importDefault(require("components/shared/ListEmptyState"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const SearchBar_1 = __importDefault(require("components/shared/SearchBar"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const useFormalReview_1 = require("src/api/useFormalReview");
const ItemDropdown = ({ asg, deleteAsg }) => {
    const ableToRemove = asg?.source ? asg?.source == 'original' : true;
    return (react_1.default.createElement("div", { className: "flex justify-between items-center h-[48px]" },
        react_1.default.createElement(ProfileType_1.default, { user: asg, title: asg?.name, srcPicture: asg?.profilePicture, size: 24, titleClassName: "typography-paragraph" }),
        react_1.default.createElement(TooltipContainer_1.default, { text: "This user can only be removed from the peer's side", show: !ableToRemove, position: "top", align: "right", useMaxWidth: false },
            react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: "var(--n-600)", iconName: ableToRemove ? 'icon-clear' : 'icon-lock_outline', customClass: ableToRemove ? 'hover-icon cursor-pointer' : 'cursor-not-allowed', onClick: () => (ableToRemove ? deleteAsg(asg) : null), dataCy: "delete-assignment" }))));
};
const LIMIT = 10;
const DropdownSelectPeerSelection = ({ assignments, phase, targetId, setEditMode, refetchSidebar }) => {
    const existingUser = assignments.map((asg) => {
        const source = asg?.source || 'original';
        return { ...asg?.actor, source };
    });
    const existingUserIds = existingUser.map((user) => user?.id);
    const { cycleId, maximumPeerCount, minimumPeerCount } = phase;
    const [search, setSearch] = (0, react_1.useState)('');
    const [users, setUsers] = (0, react_1.useState)([]);
    const [deletedUsers, setDeletedUsers] = (0, react_1.useState)([]);
    const [useTrigger, setUseTrigger] = (0, react_1.useState)(true);
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [currentAssignment, setCurrentAssignment] = (0, react_1.useState)(existingUser);
    const exclude = currentAssignment?.map((user) => user.id);
    const params = {
        excludeActorIds: exclude,
        limit: 10,
        q: search
    };
    const { data: suggestions, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } = (0, useFormalReview_1.usePeerSuggestion)(cycleId, targetId, params, {
        staleTime: 5000,
        getNextPageParam: (lastPage) => {
            if (lastPage?.data?.length === LIMIT) {
                return lastPage.pagination?.next?.olderThan;
            }
        }
    });
    const addPeerReview = (user) => {
        setUsers(users.filter((existingUser) => existingUser?.id !== user?.id));
        existingUserIds?.includes(user?.id) &&
            setDeletedUsers(deletedUsers.filter((userId) => userId == user?.id));
        setCurrentAssignment([...(currentAssignment || []), user]);
        setUseTrigger(true);
    };
    const deleteAsg = (deletedAsg) => {
        setUsers([...users, deletedAsg].sort((u, dA) => u?.name?.toLowerCase().localeCompare(dA?.name?.toLowerCase())));
        let allAssigment = (0, cloneDeep_1.default)(currentAssignment);
        allAssigment =
            allAssigment?.filter((asg) => asg?.id != deletedAsg?.id) ||
                [];
        setCurrentAssignment(allAssigment);
        existingUserIds?.includes(deletedAsg?.id) &&
            setDeletedUsers([...deletedUsers, deletedAsg?.id]);
    };
    const checkDeletedUser = () => {
        if (deletedUsers?.length > 0) {
            setShowModal(true);
        }
        else {
            submitPeer();
        }
    };
    const submitPeer = async () => {
        const params = {
            admin: true,
            actorIds: currentAssignment?.map((user) => user?.id),
            lockedIds: [],
            unlockedIds: []
        };
        const { isSuccess } = await (0, FormalReviewClient_1.submitPeerSelections)(cycleId, targetId, params);
        if (isSuccess) {
            refetchSidebar();
            setShowModal(false);
            setEditMode(null);
        }
    };
    const intersectTarget = (0, react_1.createRef)();
    (0, useIntersectionObserver_1.default)({
        target: intersectTarget,
        onIntersect: (entry) => entry.isIntersecting &&
            !isFetchingNextPage &&
            hasNextPage &&
            fetchNextPage(),
        threshold: 1
    });
    (0, react_1.useEffect)(() => {
        const newCycles = (0, flatten_1.default)(suggestions?.pages?.map((page) => {
            return page?.data?.map((d) => {
                return d;
            });
        }));
        setUsers(newCycles);
    }, [suggestions]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "w-full" },
            currentAssignment && currentAssignment?.length == maximumPeerCount && (react_1.default.createElement(BannerBox_1.default, { paddingClass: "px-[16px] py-[8px]", text: (0, HelperUtils_1.getObjectiveLocale)(`You’ve reached the maximum number`), type: "info", dataCy: "bannerbox-warning-peerselection", marginClass: "mb-[-24px]" })),
            react_1.default.createElement(MenuOutsideClickWrapper_1.default, { event: () => setUseTrigger(true) },
                react_1.default.createElement(InlineDialog_1.default, { header: (0, HelperUtils_1.getObjectiveLocale)('Suggested'), customClass: "w-full" },
                    currentAssignment &&
                        currentAssignment?.length < maximumPeerCount && (react_1.default.createElement(InlineDialog_1.default.Trigger, null,
                        react_1.default.createElement(SearchBar_1.default, { placeholder: "Search peers", onChange: (e) => setSearch(e.currentTarget.value), onFocus: () => setUseTrigger(false), fullWidth: true, iconFillColor: "var(--n-600)", dataCy: "trigger-project-alignment" }))),
                    !useTrigger && (react_1.default.createElement(InlineDialog_1.default.MenuItems, { useTrigger: useTrigger, customClass: "w-full max-h-[288px]", maxHeightWrapper: 240 },
                        isFetching && !isFetchingNextPage ? (react_1.default.createElement(LoadingComponent_1.default, null)) : users?.length > 0 ? (users?.map((user, index) => (react_1.default.createElement(InlineDialog_1.default.MenuItem, { onClick: () => addPeerReview(user), key: index },
                            react_1.default.createElement("div", { className: "flex items-center justify-between w-full" },
                                react_1.default.createElement(ProfileType_1.default, { user: user, title: user?.name, subtitle: user?.jobTitle, srcPicture: user?.profilePicture, size: 32, titleClassName: "typography-h400", subtitleClassName: "typography-h400 text-n-800", customClass: "w-[232px]" }),
                                react_1.default.createElement("p", { className: "typography-h200 text-n-800 ml-[16px] flex grow" },
                                    user?.selectedCount,
                                    "/",
                                    user?.totalAvailableQuota,
                                    ' ',
                                    (0, HelperUtils_1.getObjectiveLocale)('quota'))))))) : (react_1.default.createElement(ListEmptyState_1.default, { emptyIcon: "icon-no-result-found", size: "small", title: (0, HelperUtils_1.getObjectiveLocale)('No result found'), subtitle: (0, HelperUtils_1.getObjectiveLocale)("We couldn't find what you're looking for"), fullHeight: true })),
                        isFetchingNextPage && react_1.default.createElement(LoadingComponent_1.default, null),
                        react_1.default.createElement("div", { className: "h-[1px]", ref: intersectTarget }, "\u00A0"))))),
            react_1.default.createElement("div", { className: "my-[16px] flex items-center justify-between" },
                react_1.default.createElement("p", { className: "typography-h200 text-n-800" }, (0, HelperUtils_1.getObjectiveLocale)('Selection')),
                react_1.default.createElement("div", { className: "flex items-center" },
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" },
                        react_1.default.createElement("span", { className: "typography-h200 text-n-900 mr-[4px]" }, currentAssignment?.length),
                        (0, HelperUtils_1.getObjectiveLocale)('Selected'),
                        react_1.default.createElement("span", { className: "typography-h200 text-n-800 mx-[4px]" }, "\u00B7")),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" },
                        react_1.default.createElement("span", { className: "typography-h200 text-n-900 mr-[4px]" }, minimumPeerCount),
                        (0, HelperUtils_1.getObjectiveLocale)('Minimum'),
                        react_1.default.createElement("span", { className: "typography-h200 text-n-800 mx-[4px]" }, "\u00B7")),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-800" },
                        react_1.default.createElement("span", { className: "typography-h200 text-n-900 mr-[4px]" }, maximumPeerCount),
                        (0, HelperUtils_1.getObjectiveLocale)('Maximum')))),
            react_1.default.createElement("div", { className: "bg-n-200 rounded px-[16px]" }, currentAssignment?.map((assignment, index) => (react_1.default.createElement(ItemDropdown, { asg: assignment, key: index, deleteAsg: deleteAsg })))),
            react_1.default.createElement("div", { className: "mt-[8px] flex justify-end" },
                react_1.default.createElement(Button_1.default.Secondary, { onClick: () => setEditMode(null) }, (0, HelperUtils_1.getObjectiveLocale)('Cancel')),
                react_1.default.createElement(Button_1.default, { customClass: "ml-[8px]", onClick: checkDeletedUser }, (0, HelperUtils_1.getObjectiveLocale)('Submit')))),
        showModal && (react_1.default.createElement(ModalRemoveReviewer_1.default, { isReviewerWording: true, onSubmit: submitPeer, onCancel: () => setShowModal(false) }))));
};
exports.default = DropdownSelectPeerSelection;
